import * as React from 'react';
import { Divider, ListItemButton, ListItemIcon, ListItemText, ListSubheader, styled } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PaymentIcon from '@mui/icons-material/Payment';

const StyledListItemButton = styled(ListItemButton)(({ theme, active }) => ({
    margin: '4px 12px',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    ...(active === 'true' ? {
        background: 'linear-gradient(135deg, rgba(13, 71, 161, 0.1) 0%, rgba(25, 118, 210, 0.1) 100%)',
        color: '#0D47A1',
        fontWeight: 'bold',
        '& .MuiListItemIcon-root': {
            color: '#0D47A1',
        },
        '&:hover': {
            background: 'linear-gradient(135deg, rgba(13, 71, 161, 0.15) 0%, rgba(25, 118, 210, 0.15) 100%)',
        }
    } : {
        color: theme.palette.text.secondary,
        '&:hover': {
            background: 'rgba(0,0,0,0.04)',
            color: '#0D47A1',
            '& .MuiListItemIcon-root': {
                color: '#0D47A1',
            },
        }
    })
}));

const StyledListItemIcon = styled(ListItemIcon)({
    minWidth: '40px',
    transition: 'color 0.3s ease'
});



const StudentSideBar = () => {
    const location = useLocation();
    return (
        <>
            <React.Fragment>
                <StyledListItemButton component={Link} to="/Student/dashboard" active={(location.pathname === '/' || location.pathname === '/Student/dashboard').toString()}>
                    <StyledListItemIcon>
                        <HomeIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Home" primaryTypographyProps={{ fontWeight: (location.pathname === '/' || location.pathname === '/Student/dashboard') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/Student/subjects" active={location.pathname.startsWith('/Student/subjects').toString()}>
                    <StyledListItemIcon>
                        <ClassOutlinedIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Subjects" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/subjects') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/Student/assignments" active={location.pathname.startsWith('/Student/assignments').toString()}>
                    <StyledListItemIcon>
                        <AssignmentIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Assignments" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/assignments') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/Student/attendance" active={location.pathname.startsWith('/Student/attendance').toString()}>
                    <StyledListItemIcon>
                        <ClassOutlinedIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Attendance" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/attendance') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/Student/complain" active={location.pathname.startsWith('/Student/complain').toString()}>
                    <StyledListItemIcon>
                        <AnnouncementOutlinedIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Complain" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/complain') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/Student/fees" active={location.pathname.startsWith('/Student/fees').toString()}>
                    <StyledListItemIcon>
                        <PaymentIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Fee Payment" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/fees') ? 700 : 500 }} />
                </StyledListItemButton>
            </React.Fragment>
            <Divider sx={{ my: 2, mx: 2, borderColor: 'rgba(0,0,0,0.08)' }} />
            <React.Fragment>
                <ListSubheader component="div" inset sx={{ background: 'transparent', fontWeight: 700, letterSpacing: '0.5px', fontSize: '0.75rem', textTransform: 'uppercase', color: '#94a3b8' }}>
                    User
                </ListSubheader>
                
                <StyledListItemButton component={Link} to="/Student/profile" active={location.pathname.startsWith('/Student/profile').toString()}>
                    <StyledListItemIcon>
                        <AccountCircleOutlinedIcon />
                    </StyledListItemIcon>
                    <ListItemText primary="Profile" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/Student/profile') ? 700 : 500 }} />
                </StyledListItemButton>
                
                <StyledListItemButton component={Link} to="/logout" active={location.pathname.startsWith('/logout').toString()}>
                    <StyledListItemIcon>
                        <ExitToAppIcon color="error" />
                    </StyledListItemIcon>
                    <ListItemText primary="Logout" primaryTypographyProps={{ fontWeight: location.pathname.startsWith('/logout') ? 700 : 500, color: '#d32f2f' }} />
                </StyledListItemButton>
            </React.Fragment>
        </>
    )
}

export default StudentSideBar